import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      whyJoinBanner: {
        livejasmin: {
          whyJoinUs: {
            ...defineMessages({
              title: {
                id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.title',
                defaultMessage: 'Why <b>join us?</b>',
              },
            }),
            earningsCard: {
              ...defineMessages({
                title: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.earningsCard.title',
                  defaultMessage: 'Top industry earnings',
                },
                bullet1: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.earningsCard.bullet1',
                  defaultMessage: 'Millions of website visits',
                },
                bullet2: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.earningsCard.bullet2',
                  defaultMessage: 'Over {amountPrizes} in monthly cash prizes',
                },
                bullet3: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.earningsCard.bullet3',
                  defaultMessage: '{numMonths} months of traffic boost',
                },
              }),
            },
            freedomCard: {
              ...defineMessages({
                title: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.freedomCard.title',
                  defaultMessage: 'Flexibility & freedom',
                },
                bullet1: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.freedomCard.bullet1',
                  defaultMessage: 'Mobile-ready engagement',
                },
                bullet2: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.freedomCard.bullet2',
                  defaultMessage: 'Extra privacy, hide face option',
                },
                bullet3: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.freedomCard.bullet3',
                  defaultMessage: 'Immediate and various payout options',
                },
              }),
            },
            safetyCard: {
              ...defineMessages({
                title: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.safetyCard.title',
                  defaultMessage: 'Safety, security & support',
                },
                bullet1: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.safetyCard.bullet1',
                  defaultMessage: 'Geo-blocking privacy settings',
                },
                bullet2: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.safetyCard.bullet2',
                  defaultMessage: 'Training & wellness initiatives',
                },
                bullet3: {
                  id: 'pages.landing.whyJoinBanner.livejasmin.whyJoinUs.safetyCard.bullet3',
                  defaultMessage: '24/7 live chat support',
                },
              }),
            },
          },
        },
      },
    },
  },
};
